/*==========================================================
	      SEARCH MODAL
==========================================================*/

$("[data-modal-id='searchPopup']").click(function (event) {
  event.preventDefault();
  var modalBox = $(this).attr("data-modal-id");
  $("#" + modalBox).fadeIn();
  $(".modal-cover").fadeIn("fast");
  $("#searchPopup .searchInput").focus();
  return false;
});

function closeSearchModal() {
  $("#searchPopup").fadeOut("fast");
  $(".modal-cover").fadeOut();
  $("#searchBtn").focus();

  // Make sure topNav section of sticky nav is visible, so that focus can return properly
  if ($("header").hasClass("scrollingDownward")) {
    $("header").removeClass("scrollingDownward").addClass("scrollingUp");
  }
}

$("#searchPopup .close").click(function () {
  closeSearchModal();
  return false;
});

// Close on tab out
// $("body").on("keydown", "#searchPopup", function (e) {
//   if (e.keyCode === 9) {
//     // tab
//     setTimeout(function () {
//       // Set quick time delay to allow for next element to focus in before evaluating

//       // If current focused element is outside of flyout, close it
//       if ($(document.activeElement).parents("#searchPopup").length !== 1) {
//         closeSearchModal();
//       }
//     }, 50);
//   } else if (e.keyCode === 13) {
//     // Enter key - close search modal when cludo is about to appear next
//     $("#searchPopup").fadeOut("fast");
//     $(".modal-cover").fadeOut();
//   } else if (e.keyCode === 27) {
//     // Escape key - close search modal
//     closeSearchModal();
//   }
// });

// Close search modal (results modal will appear right after)
$("#searchPopup .searchButton").click(function () {
  closeSearchModal();
});

// searchPopup trap focus
$(function () {
  const $searchPopup = $("#searchPopup"),
    $searchBtn = $("#searchBtn"),
    $closeBtn = $searchPopup.find(".close");

  $searchBtn.on("click", function () {
    trap_focus($searchPopup, "searchPopupTrap");
  });

  $closeBtn.on("click", function () {
    remove_trap_focus($searchPopup, "searchPopupTrap");
  });
});

//add attributes to google search elements
$(window).load(function () {
    $(".searchContainer table").attr("role", "presentation");
    $(".searchContainer button.gsc-search-button").attr("aria-label", "View Search Results");
});